import Component from './NotificationForm.component';
import { NOTIFICATION_TYPES } from '/b2b/notifications/constants';
import NotificationSavedToast from './NotificationSavedToast';
import React from 'react';
import UIActions from '/b2b/common/state/ui/UI.actions';
import { connect } from 'react-redux';
import fromState from '/b2b/common/state/selectors';

const mapStateToProps = state => {
    const permissions = Object.values(NOTIFICATION_TYPES).filter(value =>
        fromState.Auth.user.hasPermission(state, {
            toPerform: 'write',
            on: value,
        })
    );

    return {
        loading: fromState.Auth.user.isLoading(state),
        permissions,
    };
};

// Wired here (rather than in each view wrapper) so both the user
// (`AccountNotifications`) and admin (`UserNotifications`) views get the
// success toast on save.
const mapDispatchToProps = dispatch => ({
    onSaved: () =>
        dispatch(
            UIActions.createSnack('notifications.saved', {
                // Render our own white card (green check + bold label, no close
                // button) instead of the default success variant.
                content: (key, message) => <NotificationSavedToast key={key} message={message} />,
                autoHideDuration: 3000,
                anchorOrigin: { vertical: 'bottom', horizontal: 'center' },
            })
        ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
